import aload from 'aload';


export default angular.module('cian.newbuild.aload', [])
  .directive('aload', () => {
    return () => {
      if (document.readyState === 'complete') {
        aload();
      }
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/serp/directives/aload.dir.js